import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { AlertTriangle, X } from 'lucide-react';

// Advarsel når en Admin er i ferd med å nedgradere seg selv
export const SelfDemoteModal = ({ toRole, onConfirm, onCancel }) => {
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onCancel(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onCancel]);
  const label = toRole === 'org_admin' ? 'Skyteleder' : 'Medlem';
  return createPortal(
    <div className="fixed inset-0 z-[130] bg-black/70 flex items-center justify-center p-4" onClick={onCancel} data-testid="self-demote-overlay">
      <div className="bg-gray-800 border border-red-500/50 rounded-xl w-full max-w-md p-5 space-y-4" onClick={(e) => e.stopPropagation()} data-testid="self-demote-modal">
        <div className="flex items-start gap-3">
          <AlertTriangle className="w-7 h-7 text-red-400 shrink-0" />
          <div className="flex-1 min-w-0">
            <h3 className="text-white font-bold text-lg">Nedgradere deg selv til {label}?</h3>
          </div>
          <button type="button" onClick={onCancel} className="p-1 text-gray-400 hover:text-white" aria-label="Lukk" data-testid="self-demote-close"><X className="w-5 h-5" /></button>
        </div>
        <div className="text-sm text-gray-200 space-y-2">
          <p>Du er i ferd med å fjerne dine egne <strong>Admin</strong>-rettigheter.</p>
          <p className="text-red-300 font-medium">Du kan ikke oppgradere deg selv tilbake til Admin etterpå.</p>
          <p className="text-gray-400">Bare en annen Admin i klubben (eller Aktivlogg Super Admin) kan gi deg Admin-rettighetene tilbake.</p>
        </div>
        <div className="flex flex-col-reverse sm:flex-row sm:justify-end gap-2">
          <button type="button" onClick={onCancel} autoFocus className="h-11 px-4 rounded-lg bg-yellow-500 hover:bg-yellow-600 text-gray-900 font-semibold" data-testid="self-demote-cancel">Avbryt – behold Admin</button>
          <button type="button" onClick={onConfirm} className="h-11 px-4 rounded-lg bg-red-600 hover:bg-red-700 text-white font-semibold" data-testid="self-demote-confirm">Ja, nedgrader meg</button>
        </div>
      </div>
    </div>,
    document.body
  );
};
